import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const solutionSlice = createSlice({
    name: 'solution',
    initialState,
    // reducers: {},
})

export default solutionSlice.reducer
